import { render, staticRenderFns } from "./FTPSetup.vue?vue&type=template&id=87b0b09e&"
import script from "./FTPSetup.vue?vue&type=script&lang=ts&"
export * from "./FTPSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QCard})
